import { animate, style, transition, trigger } from '@angular/animations';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { LocaleService } from '@app/locale.service';
import {
  ApiService,
  Hostel,
  HostelTravelGuide,
  TravelGuideResponse,
} from '@app/services/api/api.service';
import { BehaviorSubject, Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'app-hostel-travel-guide',
  templateUrl: './hostel-travel-guide.component.html',
  styleUrls: ['./hostel-travel-guide.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [
    trigger('fadeIn', [
      transition(':enter', [
        style({ transform: 'translateY(-8px)', opacity: 0.4 }),
        animate(
          '0.15s ease-in',
          style({ transform: 'translateY(0)', opacity: 1 })
        ),
      ]),
    ]),
  ],
})
export class HostelTravelGuideComponent {
  @Input()
  public hostel?: Hostel;
  @Input() firstImageUrl!: string;

  public desktop = new BehaviorSubject(true);
  public travelGuide = new BehaviorSubject<TravelGuideResponse | null>(null);
  private destroyed = new Subject<void>();
  public travelGuideData: HostelTravelGuide | null = null;
  public error = new BehaviorSubject<boolean>(false);
  public loading = new BehaviorSubject<boolean>(false);
  public locale = this.localeService.currentLocale.value;

  constructor(
    private responsive: BreakpointObserver,
    private api: ApiService,
    private localeService: LocaleService
  ) {}

  getLocalizedText(text: { [key: string]: string } | undefined): string {
    if (!text) return '';
    return text[this.locale] || text['en'] || '';
  }

  scrollToSection(sectionId: string, event: Event) {
    event.preventDefault();
    const element = document.getElementById(sectionId);
    if (element) {
      const yOffset = -80; // Adjust this value to account for fixed headers
      const y =
        element.getBoundingClientRect().top + window.pageYOffset + yOffset;
      window.scrollTo({ top: y, behavior: 'smooth' });
    }
  }

  ngOnChanges() {
    if (this.hostel) {
      this.loading.next(true);
      this.error.next(false);

      this.api.getTravelGuide('hostel', this.hostel._id).subscribe({
        next: (res) => {
          console.log('res', res);
          this.travelGuide.next(res);
          if (res.success && res.data && 'hostel' in res.data) {
            this.travelGuideData = res.data as HostelTravelGuide;
          } else {
            this.error.next(true);
          }
          this.loading.next(false);
        },
        error: () => {
          this.error.next(true);
          this.loading.next(false);
        },
      });
    }
  }

  ngOnInit() {
    this.responsive
      .observe([Breakpoints.XSmall, Breakpoints.Small, Breakpoints.Medium])
      .pipe(takeUntil(this.destroyed))
      .subscribe((result) => {
        if (result.matches) {
          this.desktop.next(false);
        } else {
          this.desktop.next(true);
        }
      });

    if (this.hostel) {
      this.loading.next(true);
      this.error.next(false);
      this.api.getTravelGuide('hostel', this.hostel._id).subscribe({
        next: (res) => {
          this.travelGuide.next(res);
          if (res.success && res.data && 'hostel' in res.data) {
            this.travelGuideData = res.data as HostelTravelGuide;
          } else {
            this.error.next(true);
          }
          this.loading.next(false);
        },
        error: () => {
          this.error.next(true);
          this.loading.next(false);
        },
      });
    }
  }

  ngOnDestroy() {
    this.destroyed.next();
    this.destroyed.complete();
  }
}
